export enum LogMessageDateRange {
  LAST_24_HOURS = 'LAST_24_HOURS',
  LAST_3_DAYS = 'LAST_3_DAYS',
  LAST_WEEK = 'LAST_WEEK',
  LAST_3_WEEKS = 'LAST_3_WEEKS',
  LAST_6_WEEKS = 'LAST_6_WEEKS'
}

export enum MessageType {
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  ERROR = 'ERROR'
}

export interface LogMessageSearchOptions {
  page: number;
  size?: number;
  sort?: 'id' | 'date' | 'chargePointName' | 'centralSystemName' | 'messageVersion' | 'messageAction' | 'messageType';
  descending?: boolean;
  range?: LogMessageDateRange;
  types?: MessageType[];
  versions?: string[];
  actions?: string[];
  chargePoints?: string[]; // chargePointName
  centralSystems?: string[]; // centralSystemName
}

export interface Message {
  id: number;
  date: Date;
  chargePointName: string;
  centralSystemName: string;
  messageVersion: string;
  messageAction: string;
  messageType: string;
  headers: string;
  payload: string;
  chargePointMessage: string;
}
